import LndButton from '@components/LndButton';
import { useAuth } from '@contexts/AuthContext';
import { MasqueradeUser } from '@customTypes/auth/Auth';
import LocalStorageKey from '@enums/LocalStorageKey';
import LocalStorageService from '@services/LocalStorageService';
import { queryClient } from '../../libs/queryClient';
import React from 'react';
import styles from './styles.module.scss';

interface MasqueradeActiveSessionProps {
  user: MasqueradeUser;
}

const MasqueradeActiveSession: React.FC<MasqueradeActiveSessionProps> = ({
  user,
}: MasqueradeActiveSessionProps) => {
  const { setMasqueradeLogin, isMasquerading } = useAuth();

  const stopMasquerading = () => {
    LocalStorageService.removeItem(LocalStorageKey.MASQUERADE_USER);
    LocalStorageService.removeItem(LocalStorageKey.MASQUERADE_OPERATOR_EMAIL);
    // Clear React Query cache when stopping masquerading to prevent showing masqueraded user's data
    queryClient.clear();
    setMasqueradeLogin(null);
  };

  return (
    <div className={`${styles.MasqueradeWrapper}`}>
      <div className={`${styles.MasqueradeContainer}`}>
        <div className='text-xs font-semibold'>
          You are now masquerading as <strong>{user?.name}</strong>
        </div>
        <LndButton
          variant="danger"
          onClick={stopMasquerading}
          loading={isMasquerading}
          className='!p-[7px] !h-[27px] !text-xs'
        >
          Stop Masquerading
        </LndButton>
      </div>
    </div>
  );
};

export default MasqueradeActiveSession;
